export default {
  INTERNET_STATUS_STATE_MANAGER: Symbol.for('INTERNET_STATUS_STATE_MANAGER'),
  INTERNET_STATUS_SUBSCRIPTION: Symbol.for('INTERNET_STATUS_SUBSCRIPTION'),
  GET_INTERNET_STATUS_SERVICE: Symbol.for('GET_INTERNET_STATUS_SERVICE'),
};
